import { ResponsiveBar } from '@nivo/bar';
import { useState, useEffect } from 'react';

export default function DataTransferBar(props: any) {
    const [listkey, setlistkey] = useState([
        'Outbound',
        'Inbound'
    ]);

    useEffect(() => {
        if (props.flag === 1) {
            setlistkey(['Outbound', 'Inbound']);
        } else if (props.flag === 2) {
            setlistkey(['Inbound']);
        } else if (props.flag === 3) {
            setlistkey(['Outbound']);
        }
    }, [props.flag]);

    const formatYAxis = (value: any) => {
        // Formatea el número para agregar comas en los miles
        return value.toLocaleString();
    };

    return (
        <ResponsiveBar
            data={props.data}
            keys={listkey}
            indexBy="mes"
            layout="vertical"
            groupMode="grouped"
            margin={{ top: 25, right: 80, bottom: 25, left: 80 }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={({ id }) => (id === 'Inbound' ? '#1f77b4' : '#a6cfe3')}
            defs={[
                {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: '#6a329f',
                    size: 4,
                    padding: 1,
                    stagger: true
                },
                {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: '#6d399e',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                }
            ]}
            fill={[
                {
                    match: {
                        id: 'Public-IP-In'
                    },
                    id: 'dots'
                },
                {
                    match: {
                        id: 'Public-IP-Out'
                    },
                    id: 'lines'
                }
            ]}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'GB Transfer',
                legendPosition: 'middle',
                legendOffset: -65,
                format: formatYAxis
            }}
            enableLabel={false}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
            role="application"
            ariaLabel="Nivo bar chart demo"
            barAriaLabel={e => e.id + ": " + e.formattedValue + " in country: " + e.indexValue}
            theme={{
                background: '#121212', // Fondo de la gráfica en modo oscuro
                textColor: '#ffffff', // Color de texto en modo oscuro
                axis: {
                    domain: {
                        line: {
                            stroke: '#777777',
                            strokeWidth: 1
                        }
                    },
                    ticks: {
                        line: {
                            stroke: '#777777',
                            strokeWidth: 1
                        },
                        text: {
                            fill: '#aaaaaa'
                        }
                    },
                    legend: {
                        text: {
                            fill: '#aaaaaa'
                        }
                    }
                },
                grid: {
                    line: {
                        stroke: '#444444'
                    }
                },
                tooltip: {
                    container: {
                        background: '#333333',
                        color: '#ffffff'
                    }
                }
            }}
        />
    );
}
